import React from 'react'

import { useTranslations } from 'next-intl'
import Head from 'next/head'
import Image from 'next/legacy/image'

import { LinkButton } from '@/components/buttons/Button'
import { FillerModule } from '@/components/FillerModule'
import { PageMetaTags } from '@/components/MetaTags'
import { Page } from '@/components/Page'
import { SimpleHero } from '@/components/SimpleHero'
import { getStaticPageProps } from '@/ssr/wrapper'

import AboutImage_1 from 'assets/images/about/about_image_1.png'
import AboutImage_2 from 'assets/images/about/about_image_2.png'
import NeedSomeHelp from 'assets/images/characters/need-some-help.png'

import styles from './about.module.scss'

export default function About() {
  const t = useTranslations()

  return (
    <Page>
      <PageMetaTags title={t('about_title')} description={t('about_description')} />
      <Head>
        <title>{t('route_about')}</title>
      </Head>
      <SimpleHero title={t('about_title')} subtitle={t('about_description')} />
      <div className={styles.Content}>
        <div className={styles.Image_1}>
          <Image src={AboutImage_1} alt="about-barbarian" sizes="(max-width: 1024px) 100vw, 600px" quality={100} />
        </div>
        <div className={styles.Text_1}>
          <h1>{t('about_info_tit_1')}</h1>
          <p>{t('about_info_bod_1')}</p>
        </div>
        <div className={styles.Text_2}>
          <h1>{t('about_info_tit_2')}</h1>
          <p>{t.rich('about_info_bod_2')}</p>
        </div>
        <div className={styles.Image_2}>
          <Image src={AboutImage_2} alt="about-cell" sizes="(max-width: 1024px) 100vw, 600px" quality={100} />
        </div>
      </div>
      <FillerModule
        className={styles.BottomFAQ}
        imageClassName={styles.BottomFAQImage}
        title={t('lan_need_some_help')}
        image={NeedSomeHelp}
        action={{ content: t('go_to_faq').toUpperCase(), link: '/help' }}
      >
        <span className={styles.Mobile}>
          {t.rich('lan_callout2_body', {
            TextButton: (children) => (
              <span className={styles.ReadMore}>
                <LinkButton href="/help" type="Soft">
                  {children?.toString()}
                </LinkButton>
              </span>
            ),
          })}
        </span>
        <span className={styles.Desktop}>{t('lan_faq_body')}</span>
      </FillerModule>
    </Page>
  )
}

export const getServerSideProps = getStaticPageProps()
